<template>
  <v-dialog v-model="downloadShareDialogVisible" width="700">
    <customDialog>
      <template v-slot:title>
        {{tmb('titleShare')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="downloadShareDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-col class="ma-0 pa-0" cols="12">
          <v-col class="ma-0 pa-0 pt-5 pl-7 pr-7 content" cols="12">
            <v-col class="ma-0 pa-0 mb-4 text-left" cols="12">{{tmb('msgPublishShareLink')}}</v-col>
            <!-- 데이터명이 UI에서 없어짐으로 아래 내용 삭제 -->
            <!-- <v-row class="ma-0 pa-0 mb-6" align="center">
              <v-col class="ma-0 pa-0 text-left" cols="2">{{tmb('dataName')}}</v-col>
              <v-col class="ma-0 pa-0 text-left" cols="10">{{item.dataName}}</v-col>
            </v-row> -->
            <v-row class="ma-0 pa-0 mb-6" align="center">
              <v-col class="ma-0 pa-0 text-left" cols="2">{{tmb('fileName')}}</v-col>
              <v-col class="ma-0 pa-0 text-left" cols="10">{{ `${item.name}.mp4` }}</v-col>
            </v-row>
          </v-col>
          <!-- 첫번째 분기: shareItemData.sharedLinkList가 empty인 경우 -->
          <v-col v-if="!shareItemData.sharedLinkList || shareItemData.sharedLinkList.length === 0"
            class="ma-0 pa-0 pb-7 pl-7 pr-7 content" cols="12">
            <template v-if="!fetchLoading">
              <v-row class="ma-0 pa-0 mb-6" align="center">
                <v-col class="ma-0 pa-0 text-left" cols="3">{{tmb('numURLs')}}</v-col>
                <v-col class="ma-0 pa-0" cols="2">
                  <v-select class="ma-0 pa-0" background-color="#272727" dark
                    v-model="selectedLinkCount"
                    :items="countNumList" dense hide-details outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0 mb-6" align="center">
                <v-col class="ma-0 pa-0 pr-2 text-left" cols="12">{{tmb('msgFiveDownload')}}</v-col>
              </v-row>
              <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
                <v-btn class="ma-0 pa-0 ml-2" id="blue_btn" @click="generateFileURL"
                        width="8rem" height="2rem">{{tmb('publishURLs')}}</v-btn>
              </v-row>
            </template> 
          </v-col>
          <!-- 두번째 분기: shareItemData.sharedLinkList가 empty가 아닐 때 -->
          <v-col v-else
            class="ma-0 pa-0 pb-7 content" cols="12">
            <v-col class="ma-0 pa-0 pt-2 pb-7 pl-7 pr-7 content" cols="12">
              <v-col v-for="(sharedLink, index) in shareItemData.sharedLinkList" :key="index" class="ma-0 pa-0" cols="12">
                <v-row class="ma-0 pa-0 mb-3" align="center">
                  <v-col class="ma-0 pa-0 text-left" cols="2">{{urlTitles[index]}}</v-col>
                  <v-col class="ma-0 pa-0 text-left" cols="9" ref="urlLinkElement">
                    <input id="urlText" type="text" :value="sharedLink.url" readonly />
                  </v-col>
                  <v-col class="ma-0 pa-0" cols="1">
                    <v-btn id="back_clean_btn" width="1rem" height="1rem"
                          class="ma-0 pa-0" elevation="0"
                          v-clipboard="sharedLink.url"
                          v-clipboard:success="clipboardSuccessHandler"
                          v-clipboard:error="clipboardErrorHandler">
                      <v-img max-height="2rem" max-width="2rem" class="ma-0 pa-0"
                            src="@/assets/images/icon_copy.png"></v-img>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row class="ma-0 pa-0 mb-3" align="center">
                  <v-col class="ma-0 pa-0 text-left" cols="2">{{tmb('titleStatus')}}</v-col>
                  <v-col class="ma-0 pa-0 text-left" cols="3">{{ getLinkStatus(index) }}</v-col>
                  <v-col v-if="sharedLink.status === 'CREATED'" class="ma-0 pa-0" cols="2">
                    <v-btn id="blue_btn" @click="invalidateURL(index)">{{ tmb('invalidateURL') }}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <!-- 세번째 조건: 모든 url이 다운로드가능하지 않을때 재발행 버튼이 생긴다 -->
              <v-col v-show="isAllInvalid" class="ma-0 pa-0" cols="12">
                <v-btn id="blue_btn" elevation="0" @click="confirmInitialize">{{ tmb('republishURLs') }}</v-btn>
              </v-col>
            </v-col>
            <v-col class="ma-0 pa-0 text-left" cols="12">{{ tmb('msgInvalidatedButton') }}</v-col>
            <v-col class="ma-0 pa-0 text-left" cols="12">{{ tmb('msgOnceDownload') }}</v-col>
            <v-col class="ma-0 pa-0 text-left" cols="12">{{ tmb('msgAllDownloadRepublish') }}</v-col>
          </v-col>
        </v-col>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
/**
 * 클라우드에 저장된 동영상 파일리스트에서 '공유' 버튼을 누를때 나오는 다이얼로그
 */
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';

export default {
  props: {
    dialogVisible: Boolean,
    item: Object, // 선택된 mp4파일에 대한 정보가 담겨있다. ( data명, url 주소, status 등등)
  },
  components: {
    customDialog
  },
  mixins: [mixin.common],
  data: () => ({
    urlTitles: ['URL①:', 'URL②:', 'URL③:', 'URL④:', 'URL⑤:'],
    downloadShareDialogVisible: false,
    generateFileURLCalled: false, // generateFileURL이 호출되었는지 여부를 저장
    selectedLinkCount: 1,
    shareItemData: {}, // props로 받은 item을 내부 사용 목적으로 복사할 객체    
    countNumList: [1, 2, 3, 4, 5], // 발행할 수 있는 URL 개수
    fetchLoading: false,
  }),
  // 컴포넌트가 생성될 때 props로 받은 item을 내부 데이터로 복사
  created() {
    this.initialize();
  },
  computed: {    
    // 모두 invalid면 URL재발행 버튼이 생기게 함
    isAllInvalid() {
      if (this.shareItemData.sharedLinkList) {
        // sharedLinkList가 존재하면, 모든 항목이 'valid'가 아닌지 확인
        return this.shareItemData.sharedLinkList.every(link => link.status !== 'CREATED');
      }
      return false; // sharedLinkList가 없으면 기본값은 false
    }
  },
  watch: {    
    dialogVisible: async function(visible) {
      this.downloadShareDialogVisible = visible;
      // 다이얼로그가 보이게 되면 내부 변수들 초기화
      if (visible) {
        this.initialize();
        this.fetchLoading = true;
        await this.refreshSharedLinks();
      }
    },
    downloadShareDialogVisible: function(item) {
      this.$emit('visible', item);
    },
    generateFileURLCalled: function (bCalled) {
      if (bCalled) {
        this.generateFileURLCalled = true;       
      }
    },
  },
  
  mounted() {
    this.generateFileURLCalled = false;
  },
  methods: {
    initialize() {
      this.generateFileURLCalled = false; // URL발행한 적없게 초기화
      this.shareItemData = { ...this.item }; // props.item에 대해 내부데이터로 복사
    },
    async generateFileURL() {
      const params = { count: this.selectedLinkCount };
      await this.networkController.requestShareLink(params, this.shareItemData.id).then((res) => {
        this.shareItemData = { ...this.item, sharedLinkList: res.data };
        this.generateFileURLCalled = true;
      }).catch(error => {
        this.showToastMessage(this.tmb('requestFail'));
      });    
    },
    async refreshSharedLinks() {
      // 공유된 리스트가 있는지 확인
      this.networkController.getSharedLinks({}, this.item.id).then((res) => {
        this.shareItemData = { ...this.item, sharedLinkList: res.data };
        this.fetchLoading = false;
      }).catch(error => {
        this.showToastMessage(this.tmb('requestFail'));
        this.fetchLoading = false;
      });        
    },
    // 클립보드 복사 성공 핸들러
    clipboardSuccessHandler () {
      this.showToastMessage(this.tmb('clipboardCopySuccess'));
    },
    // 클립보드 복사 에러 핸들러
    clipboardErrorHandler () {
      this.showToastMessage(this.tmb('clipboardCopyError'));
    },
    getLinkStatus(index) {
      const { sharedLinkList } = this.shareItemData;
      const link = sharedLinkList[index];
      const status = link ? link.status : '';

      if (status === 'CREATED') {
        return this.tmb('downloadAvaliable');
      } else if (status === 'STOPPED') {
        return this.tmb('downloadInvalid');
      } else if (status === 'DOWNLOADED') {
        return this.tmb('downloadComplete');
      }
    },
    async invalidateURL(index) {
      const { sharedLinkList } = this.shareItemData;
      const linkItem = sharedLinkList[index];
      const recordedVideoSharedUrlId = linkItem.id;
      try {
        await this.networkController.invalidateURL({}, recordedVideoSharedUrlId);
        // this.showToastMessage(this.tmb('requestSuccess'));
        this.refreshSharedLinks();
      } catch (error) {
        this.showToastMessage(this.tmb('requestFail'));
      }
    },
    confirmInitialize() {
      this.shareItemData = { ...this.item };
    }
  }
}
</script>

<style lang="scss" scoped>
/* .content {
  font-weight: bold;
} */
.v-list {
  background: #171921;
  border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
}
#urlText {
  background-color: white; /* 하얀색 배경 설정 */
  color: #535353;
  width: 100%; /* 부모 엘리먼트에 꽉 차게 설정 */
  border: none;
  padding: 8px; 
  box-sizing: border-box;
  border-radius: 10px;
}
</style>